import { useMemo, type ReactNode } from "react"

import { WorkspacePage } from "~/components/design-system/pages"
import { FlagInspector } from "~/features/feature-flags/client/FlagInspector"
import { useFlagPageKey } from "~/features/feature-flags/client/flag-page/useFlagPageKey"

/**
 * A flag page tab: its table beside the flag inspector, open by default. The inspector carries
 * the flag's status, defaults, details and overrides.
 */
export function FlagPageWorkspace({
  toolbar,
  children,
}: {
  toolbar: ReactNode
  children: ReactNode
}) {
  const flagKey = useFlagPageKey()
  // Memoised: the inspector re-registers whenever this node's identity changes.
  const inspector = useMemo(() => <FlagInspector flagKey={flagKey} />, [flagKey])

  return (
    <WorkspacePage
      fillContent
      toolbar={toolbar}
      inspector={inspector}
      inspectorDefaultOpen
      inspectorWidth="md"
    >
      {children}
    </WorkspacePage>
  )
}
